export const pushDataLayerEvent = (eventName: string) => {
  const data = (window as any).dataLayer;
  data &&
    data.push({
      event: eventName,
    });
};
